// eslint-disable-next-line no-restricted-exports
export { default, getStaticProps } from './[location]';
